export function formatDate(date){
    if(date){
        let year = date.substring(0, 4);
        let month = date.substring(5, 7);
        let day = date.substring(8, 10);
        return `${day}/${month}/${year}`;
    }
}

export function formatDate2(date){
    if(date && date.substring(4, 5) !== "-"){
        let day = date.substring(0, 2);
        let month = date.substring(3, 5);
        let year = date.substring(6, 10);
        return `${year}-${month}-${day}`;
    }else return date
}

export function formatDateAndTime(date){
    let year = date.substring(0, 4);
    let month = date.substring(5, 7);
    let day = date.substring(8, 10);
    return `${day}/${month}/${year} - ${date.substring(11, 19)}`;
}

export function formatDateBR(date){
    if(date){
        let year = date.substring(0, 4);
        let month = date.substring(5, 7);
        let day = date.substring(8, 10);
        return `${day}/${month}/${year}`;
    }
}

export function formatDateTimeBR(date){
    if(date){
        let year = date.substring(0, 4);
        let month = date.substring(5, 7);
        let day = date.substring(8, 10);

        let hour = date.substring(11, 13);
        let minutes = date.substring(14, 16);
        let seconds = date.substring(17, 19);

        return `${day}/${month}/${year} - ${hour}:${minutes}:${seconds}`;
    }
}


// WEBPACK FOOTER //
// ./src/functions/formatDate.js